// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Modal, { ModalPresentationProps } from "@insite/mobius/Modal"; // Valtech Custom Code
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

/* Valtech Custom Code - Start */
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import Modal, { ModalPresentationProps } from "@store/MobiusOverrides/Modal/Modal";
import expandProps from "@toolkit/Framework/Common/Utilities/expandProps";
/* Valtech Custom Code - End */

// Foundation --->
import { formGridProps } from "@store/Themes/common/props/form";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

interface OwnProps {
    modalIsOpen: boolean;
    headlineText: React.ReactNode;
    messageText: React.ReactNode;
    cancelButtonText: string;
    submitButtonText: string;
    extendedStyles?: TwoButtonModalStyles;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmit: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    cancelTestSelector?: string;
    submitTestSelector?: string;
    dataTestSelector?: string;
    // Valtech Custom Code
    overridedStyles?: TwoButtonModalStyles;
    setOverlayScrimRef?: (ref: React.Ref<HTMLDivElement>) => void;
    // Foundation
    hideButtons?: boolean;
}

type Props = OwnProps;

export interface TwoButtonModalStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    textGridItem?: GridItemProps;
    messageText?: TypographyProps;
    buttonsGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
}

export const twoButtonModalStyles: TwoButtonModalStyles = {
    modal: {
        sizeVariant: "small",
    },
    cancelButton: {
        variant: "secondary",
    },
};

class TwoButtonModal extends React.Component<Props> {
    private readonly styles: TwoButtonModalStyles;

    constructor(props: Props) {
        super(props);

        this.styles = expandProps(twoButtonModalStyles, props.extendedStyles, props.overridedStyles); // Valtech Custom Code
    }

    formCancelHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        this.props.onCancel(e);
    };

    formSubmitHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        this.props.onSubmit(e);
    };

    formCloseHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        if (this.props.onClose) {
            this.props.onClose(e);
        } else {
            this.props.onCancel(e);
        }
    };

    render() {
        const styles = this.styles;

        return (
            <Modal
                headline={this.props.headlineText}
                {...styles.modal}
                isOpen={this.props.modalIsOpen}
                data-test-selector={this.props.dataTestSelector}
                handleClose={this.formCloseHandler}
                // Valtech Custom Code
                setOverlayScrimRef={this.props.setOverlayScrimRef}
            >
                {/* Valtech Custom Code - Start */}
                <Typography {...styles.messageText} data-test-selector="twoButtonModal_MessageContent">
                    {this.props.messageText}
                </Typography>
                {!this.props.hideButtons /* Foundation */ ? (
                    <FormActions>
                        <Button
                            {...styles.submitButton}
                            onClick={this.formSubmitHandler}
                            data-test-selector={this.props.submitTestSelector}
                        >
                            {this.props.submitButtonText}
                        </Button>
                        <Button
                            {...styles.cancelButton}
                            onClick={this.formCancelHandler}
                            data-test-selector={this.props.cancelTestSelector}
                        >
                            {this.props.cancelButtonText}
                        </Button>
                    </FormActions>
                ) : null}
                {/* Valtech Custom Code - End */}
            </Modal>
        );
    }
}

export default TwoButtonModal;
